export const review_observation_index = ['review_observation.index']
export const review_observation_edit = ['review_observation.edit']
export const review_observation_next = ['review_observation.next']

export default [].concat(
    review_observation_index,
    review_observation_edit,
    review_observation_next
)
